import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const OpenLinkIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M11.5556 11.5556H1.44444V1.44444H6.5V0H1.44444C1.06135 0 0.693954 0.152182 0.423068 0.423068C0.152182 0.693954 0 1.06135 0 1.44444V11.5556C0 11.9386 0.152182 12.306 0.423068 12.5769C0.693954 12.8478 1.06135 13 1.44444 13H11.5556C12.35 13 13 12.35 13 11.5556V6.5H11.5556V11.5556ZM7.94444 0V1.44444H10.5372L3.43778 8.54389L4.45611 9.56222L11.5556 2.46278V5.05556H13V0H7.94444Z"
    />
  </svg>
);

OpenLinkIcon.propTypes = {
  color: string.isRequired,
  fillOpacity: number,
  ...helpers.iconDimensionsPropTypes,
};

OpenLinkIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(13, 13),
};

export default OpenLinkIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/open.js